import { render } from "./ThreeUsers.vue?vue&type=template&id=487d7cd0"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/ThreeUsers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "487d7cd0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('487d7cd0', __exports__)) {
    api.reload('487d7cd0', __exports__)
  }
  
  module.hot.accept("./ThreeUsers.vue?vue&type=template&id=487d7cd0", () => {
    api.rerender('487d7cd0', render)
  })

}


export default __exports__